import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NotFoundComponent } from '@common/components/NotFoundComponent/notFound.component';

@NgModule({
  imports: [
    TranslateModule,
  ],
  declarations: [
    NotFoundComponent,
  ],
  exports: [
    NotFoundComponent,
  ],
})
export class NotFoundModule {}



// WEBPACK FOOTER //
// ./src/app/common/components/NotFoundComponent/notFound.module.ts